import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const header = document.querySelector('.header')

ScrollTrigger.create({
	trigger: '.hero',
	scrub: true,
	start: '102% bottom',
	end: '102% bottom',
	onEnter() {
		header.classList.remove('active')
	},
	onLeave() {
		header.classList.add('active')
	},
	onEnterBack() {
		header.classList.add('active')
	},
	onLeaveBack() {
		header.classList.remove('active')
	},
})
